import { IconRalphWiggum } from "@/assets/icons/IconRalphWiggum";
import { IconChevronDown } from "@/assets/icons/geist/IconChevronDown";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/podkit/dropdown/DropDown";
import { cn } from "@/components/podkit/lib/cn";
import { Check } from "lucide-react";
import { IconCodeAssistant } from "central-icons/IconCodeAssistant";
import { AgentMode } from "@/components/ai/prompt-input/agent-mode";

export const AgentModeDropdown = ({
    mode,
    onModeChange,
}: {
    mode: AgentMode;
    onModeChange: (mode: AgentMode) => void;
}) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                className={cn(
                    "inline-flex h-8 min-w-24 items-center justify-between gap-1.5 rounded-md border border-border-base bg-transparent px-2 text-sm font-medium text-content-secondary",
                    "hover:bg-surface-hover focus:outline-none focus-visible:ring-0",
                )}
            >
                <div className="flex items-center gap-1.5">
                    {mode === AgentMode.Ralph ? <IconRalphWiggum size={16} /> : <IconCodeAssistant size={16} />}
                    <span>{mode === AgentMode.Ralph ? "Ralph" : "Agent"}</span>
                </div>
                <IconChevronDown size="sm" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" side="top" className="w-24">
                <DropdownMenuItem onClick={() => onModeChange(AgentMode.Agent)} data-tracking-id="agent-mode-agent">
                    <IconCodeAssistant size={16} className="mr-2" />
                    Agent
                    {mode === AgentMode.Agent && <Check size={14} className="ml-auto" />}
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => onModeChange(AgentMode.Ralph)} data-tracking-id="agent-mode-ralph">
                    <IconRalphWiggum size={16} className="mr-2" />
                    Ralph
                    {mode === AgentMode.Ralph && <Check size={14} className="ml-auto" />}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
